<div class="panelLocations" id="prospectsPanelContainer">
  <loading [isLoading]="isLoading"></loading>

  <div class="header-panel">
    <h3>Prospectos</h3>

    <div class="tools-buttons-container">
      <div class="tool-button" (click)="isToolButtonPressed = !isToolButtonPressed" id="prospectsToolsButton" matTooltip="Herramientas">
        <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
        <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
      </div>
    </div>
  </div>

  <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical" id="prospectsButtonToolContainer">
    <div class="tools-buttons-vertical-container">
      <div class="vertical-tools" id="individualToolsBar">
        <div class="tool-option-vertical" (click)="openFilters()" id="prospectsFilterButton">
          <mat-icon *ngIf="ApplyFilter">filter_alt_off</mat-icon>
          <img [src]="'filtrar_boton.svg' | findUrl" *ngIf="!ApplyFilter">
          <span class="tool-label">Filtrar</span>
        </div>
        <div class="tool-option-vertical" (click)="getTabExcel()" id="prospectsExcelButton">
          <img [src]="'xls_bton.svg' | findUrl">
          <span class="tool-label">Descargar Excel de Prospectos</span>
        </div>
        <div class="tool-option-vertical" (click)="reloadProspectos()" id="prospectsReloadButton">
          <img [src]="'boton_sincronizar.svg' | findUrl">
          <span class="tool-label">Recargar Prospectos</span>
        </div>
      </div>
    </div>
  </div>

  <div class="locations-tab-group" *ngIf="categoriesTabs.length > 0">
    <mat-tab-group mat-stretch-tabs (selectedTabChange)="selectTab($event)" id="prospectsTabContent">
      <mat-tab *ngFor="let categoryItem of categoriesTabs; let i = index" [label]="i.toString()">
        <ng-template mat-tab-label>
          <div id="prospectsTabLabel" class="categoryTabLabel">
            <img [src]="categoryItem.category.panelIcon | findUrl" width="25px">
            <label class="totals-label">{{categoryItem.total}} {{categoryItem.category.shortName}}</label>
          </div>
        </ng-template>

        <ng-template matTabContent>
          <div class="tab-content-wrapper">
            <div class="control-items" (scroll)="onScroll($event)">
              <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                <div class="row itemPanel-flex">
                  <div class="item-left">
                    <img class="item-icon" [src]="(item.panelIcon || categoryItem.category.panelIcon) | findUrl">
                  </div>
                  <div class="row-item item-middle">
                    <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                      <div class="status-flag-set-locations">
                        <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon" [style.color]="flag.priorityHex">{{flag.flagIcon}}</mat-icon>
                      </div>
                    </div>
                    <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                    <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                  </div>
                  <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                    <div class="copy-to-clipboard">
                      <img [src]="'boton_copiar_azul.svg' | findUrl">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="$Items.length == 0 && !isLoading">
                <div class="row-item col-12">
                  <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
